import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ErxBonusLandingPageTypesOfPrescriptionsCardsV1 } from './ErxBonusLandingPageTypesOfPrescriptionsCards'

export const ErxBonusLandingPageTypesOfPrescriptionsV1: FC = () => {
  return (
    <div className="py-8 tablet:py-12">
      <div className="px-5 text-center text-2xl font-medium tablet:px-0 tablet:text-3xl">
        <FormattedMessage id="deErx.bonus.typesOfPrescriptions.title" />
      </div>
      <ErxBonusLandingPageTypesOfPrescriptionsCardsV1 />
    </div>
  )
}
